import React, { ReactNode, useState } from 'react';
import styles from './scss/layout.module.scss';
import TopBar from './topBar';
import LeftNav from './leftNav';
import { Outlet, useLocation } from 'react-router-dom';
import RightNav from './rightNav';
import AiChat from '../newpages/aiChat/aiChat';
import { useDispatch, useSelector } from 'react-redux';
import { dashboardAction } from '../store/slices/dashboard';


type layoutprops = {
  children?: ReactNode
}

const Layout = ({ children }: layoutprops) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const isCampaignPage = location.pathname === '/campaigns' || location.pathname === '/reports';
  const showAiChat = useSelector((state: any) => state.dashboardReducer.showAiChat);
  // console.log("showAiChat", showAiChat);

  return (
    <div className={styles.layoutsec}>
      <div className={styles.ltstopbar}>
        <TopBar />
      </div>
      <div className={styles.ltsmainsec}>
        <div className={styles.ltsleftnavsec}><LeftNav /></div>
        <div className={`${styles.ltscentersec} ${isCampaignPage ? styles.heightcamp : ''}`} id='forportal'>
          <Outlet />
          {showAiChat && <AiChat />}
        </div>
        {/* <div className={styles.ltsrightnavsec}><RightNav /></div> */}
      </div>
    </div>
  )
}

export default Layout
